<template>
    <AppSeoTags>
        <title>Tyre News</title>

        <link head-key="canonical" rel="canonical" :href="currentUrl">
    </AppSeoTags>

    <AppJumbotron>
        <h1 class="text-3xl lg:text-4xl xl:text-5xl tracking-wide text-white max-w-[500px]">
            Read the latest <strong>tyre news</strong> at {{ usePage().props.value.config.name }}
        </h1>
    </AppJumbotron>

    <div v-if="latestArticle" class="bg-grey-100 py-4">
        <AppContainer>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center gap-8">
                <div>
                    <span class="bg-red rounded-full text-dark py-2 px-4 font-bold">
                        <FontAwesomeIcon :icon="['fab', 'youtube']"></FontAwesomeIcon>
                        Latest Video
                    </span>

                    <h2 class="text-3xl text-dark mt-4 font-bold">{{ latestArticle.title }}</h2>

                    <p class="mt-4">{{ latestArticle.excerpt ?? latestArticle.excerpt_from_description }}</p>

                    <AppButton class="mt-4" theme="secondary" :href="route('news.show', latestArticle)">
                        View Article
                    </AppButton>
                </div>

                <div class="col-span-1 lg:col-span-2">
                    <AppVideo :type="latestArticle.videos[0].type" :clip="latestArticle.videos[0].video_id"></AppVideo>
                </div>
            </div>
        </AppContainer>
    </div>

    <AppContainer>
        <h3 class="text-dark text-bold text-3xl my-8">The latest tyre news</h3>

        <MasonryWall class="my-8" :items="newsPages.data" :columns="3" :gap="16" v-slot="slotProps">
            <NewsArticleCard
                :key="slotProps.index"
                :title="slotProps.item.title"
                :excerpt="slotProps.item.excerpt ?? slotProps.item.excerpt_from_description"
                :video="slotProps.item?.videos?.[0]"
                :image="slotProps.item.image"
                :link="route('news.show', slotProps.item)"
                :date="slotProps.item.created_at"
            ></NewsArticleCard>
        </MasonryWall>

        <AppPagination class="justify-center" :links="newsPages.links"></AppPagination>
    </AppContainer>
</template>

<script setup>
import {useCurrentPath} from "@/Composables/useCurrentPath";
import {usePage} from "@inertiajs/inertia-vue3";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import AppJumbotron from "@/Components/AppJumbotron";
import AppContainer from "@/Layouts/AppContainer";
import AppButton from "@/Components/AppButton";
import AppVideo from "@/Components/AppVideo";
import NewsArticleCard from "@/Components/Articles/ArticleCard";
import MasonryWall from "@/Components/MasonryWall";
import AppPagination from "@/Components/AppPagination";
import AppSeoTags from "@/Components/AppSeoTags";

const props = defineProps({
    newsPages: Array,
    latestArticle: Object
});

const {url: currentUrl} = useCurrentPath();
</script>

<style scoped>

</style>
